/** self-registration is LEAD-only, so the contact does not vary by brand */
export const SUPPORT_PHONE = '044 384 55 77';
export const SUPPORT_PHONE_HREF = '+41443845577';
